module.exports = __webpack_public_path__ + "static/media/noGiveup.5bf8c68c.svg";